// src/pages/Dashboard/components/ChatPanel/ChatHeader.js

import React from 'react';

/**
 * Header do chat com seletor de modelo
 * @param {Array} models - Lista de modelos disponíveis
 * @param {object} selectedModel - Modelo selecionado
 * @param {function} onChangeModel - Callback ao mudar modelo
 */
const ChatHeader = ({ models, selectedModel, onChangeModel }) => {
  return (
    <div className="chat-header-dashboard">
      <h3>Chat</h3>
      <select 
        className="model-select-dashboard"
        value={selectedModel?.id || ''} 
        onChange={(e) => {
          const model = models.find(m => m.id === e.target.value);
          onChangeModel(model);
        }}
      >
        {models.map(model => (
          <option key={model.id} value={model.id}>{model.id}</option>
        ))}
      </select>
    </div>
  );
};

export default ChatHeader;